import { LOCAL_STORAGE_KEYS, orderMap } from '@constants';
import { CAMPAIGNS_FILTER_DEFAULTS } from '../constants';

function isValidStoredFilters(data) {
    if (!data || typeof data !== 'object') return false;
    return !data.order || Object.values(orderMap).includes(data.order);
}

function normalizeArray(value) {
    return Array.isArray(value) ? value.map(Number) : undefined;
}

export function isDefaultStatusesFilter(statuses = []) {
    const defaultStatuses = CAMPAIGNS_FILTER_DEFAULTS.statuses;
    if (statuses.length !== defaultStatuses.length) return false;

    const defaultStatusesSet = new Set(defaultStatuses);
    return statuses.every((status) => defaultStatusesSet.has(status));
}

export function readCampaignFiltersFromStorage() {
    try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEYS.CAMPAIGNS_FILTERS);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!isValidStoredFilters(parsed)) return null;
        return {
            ...parsed,
            statuses: normalizeArray(parsed.statuses),
            catalog_types: normalizeArray(parsed.catalog_types)
        };
    } catch (e) {
        console.warn('[campaignFiltersStorage] Failed to read filters from localStorage', e); // eslint-disable-line
        return null;
    }
}

export function saveCampaignFiltersToStorage({ filters, sorters }) {
    try {
        localStorage.setItem(
            LOCAL_STORAGE_KEYS.CAMPAIGNS_FILTERS,
            JSON.stringify({
                statuses: normalizeArray(filters.statuses),
                catalog_types: normalizeArray(filters.catalog_types),
                sort: sorters.sort ?? CAMPAIGNS_FILTER_DEFAULTS.sort,
                order: sorters.order ?? CAMPAIGNS_FILTER_DEFAULTS.order
            })
        );
    } catch (e) {
        console.warn('[campaignFiltersStorage] Failed to save filters to localStorage', e); // eslint-disable-line
    }
}
